/**
 * The `sizes` attribute for a browse-grid tile's image at a given column
 * count: the real rendered tile width (~100/columns vw on desktop), so the
 * srcset serves sharper files at 2-3 columns and smaller ones at 5-6.
 *
 * Below md the width is set by the vertical's fixed mobile column count
 * instead. 5-6 column selections clamp to 4 between md and lg (see the grid's
 * COL_CLASSES), so their sizes must say 25vw there or tablets fetch an
 * undersized file. The page content is capped at 120rem (1920px), so beyond
 * that the tile width is a fixed pixel value, not a vw share — without the
 * cap entry wide displays would over-fetch ever-larger files.
 *
 * Extracted from the grid so the value has one definition and a test of its
 * own; the grid is its only caller.
 */
export const directoryTileImageSizes = (
    columns: number,
    mobileColumns: 1 | 2,
): string => {
    const cappedTilePx = Math.round((1920 - 96 - 24 * (columns - 1)) / columns);
    const desktopTileVw = `${Math.round(100 / columns)}vw`;
    const mobileTileVw = mobileColumns === 1 ? '100vw' : '49vw';
    return columns >= 5
        ? `(min-width: 1920px) ${cappedTilePx}px, (min-width: 1024px) ${desktopTileVw}, (min-width: 768px) 25vw, ${mobileTileVw}`
        : `(min-width: 1920px) ${cappedTilePx}px, (min-width: 768px) ${desktopTileVw}, ${mobileTileVw}`;
};
